export default {
    taxFilingIndividualId: 'TAX_RMB_SUMARY_STATIC1',
    taxDependent: 'TAX_RMB_SUMARY_STATIC2',
    filing: 'TAX_FILING_STATIC_TEXT1',
    jointFiler: 'TAX_RMB_SUMARY_STATIC33',
    jointFilerOutsideHousehold: 'TAX_RMB_SUMARY_STATIC3',
}